import {
  Avatar,
  Card,
  CardContent,
  CardHeader, Chip, Typography
} from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import { selectGroups } from "../../features/daoTrang/daoTrangSlice";

const reg = new RegExp(/Tổ (\d)/i);

export function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}
export function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

export const UserChip = ({ user, deleteIcon }) => {
  // console.log({user})
  // const { name="user", address="address" } = user;
  var name = "name name";
  var address = "address";
  if (user) {
    name=user.name;
    address = user.address;
  }
  var m = address?address.match(/\w+/):"";
  var tinh = m?"-" + m[0]:"";
  return (
    <Chip
      avatar={<Avatar {...stringAvatar(name)} deleteIcon={deleteIcon}></Avatar>}
      label={name + tinh}
    />
  );
};
